import { render, staticRenderFns } from "./ProductsColorsQuickAdd.vue?vue&type=template&id=77b06ca3&"
import script from "./ProductsColorsQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsColorsQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports